import PropTypes from "prop-types"
import intl from 'react-intl-universal'
import Dialog from "material-ui/Dialog"
import { TextModal, TitleModal } from './styled'
import Button from "components/button"

const ModalDeleteLoad = ({ open, close, onClick, showInfoReturnQuantity }) => (
  <Dialog
    open={open}
    contentStyle={{ width: "500px" }}
  >
    <TitleModal>{intl.get('load-building.page-flow.modal-delete-load.warning')}</TitleModal>
    <TextModal>{intl.get('load-building.page-flow.modal-delete-load.confirm-delete')}</TextModal>
    {showInfoReturnQuantity && <TextModal>{intl.get('load-building.page-flow.modal-delete-load.warningNotFullTruck')}</TextModal>}
    <div className="botoes-modal" style={{ marginTop: '32px' }}>
      <Button
        value={intl.get('commons.cancel')}
        onClick={close}
        className="btn"
        style={{ width: '150px' }}
      />
      <Button
        buttonType="danger"
        value={intl.get('commons.delete')}
        onClick={onClick}
        className="btn margin-botao"
        style={{ width: '150px' }}
      />
    </div>
  </Dialog>
)

ModalDeleteLoad.propTypes = {
  close: PropTypes.any.isRequired,
  onClick: PropTypes.any.isRequired,
  open: PropTypes.any.isRequired,
  showInfoReturnQuantity: PropTypes.any.isRequired
}

export default ModalDeleteLoad;